import { data } from "jquery";
import { smartStrategy } from "webpack-merge";
import restAction from "../common/restAction";

const state = { 
	noneNotiReadYn : false,
	noneCallReadYn : true,
	notiCheckTime : new Date(),
	callCheckTime : new Date(),
	notiFirstConnect : true,
	callFirstConnect : true,
	notiBoardBlockId : null,
	notiBoardCommentId : null,
	showCallListPopup : false,
	showNotiListPopup : false,
	eventBackYn : false,
};
const mutations = { 
	setNoneNotiReadYn(state, payload){
		state.noneNotiReadYn = payload;
	},
	setNoneCallReadYn(state, payload){
		state.noneCallReadYn = payload;
	},
	setNotiBoardBlockId(state, payload){
		state.notiBoardBlockId = payload;
	},
	setNotiBoardCommentId(state, payload){
		state.notiBoardCommentId = payload;
	},
	setShowNotiListPopup(state, payload){
		state.showNotiListPopup = payload;
	},
	setShowCallListPopup(state, payload){
		state.showCallListPopup = payload;
	},
	setEventBackYn(state, payload){
		state.eventBackYn = payload;
	}
};
const actions = { 
	setNoneNotiReadYn(context, payload){
		let time= new Date();
		let connectTime = state.notiCheckTime.getTime();
		let currentTime = time.getTime();
		let timeGap = parseInt((currentTime - connectTime)/ (1000*60));   
   
		if((timeGap >= 1 || state.notiFirstConnect)){
			const param = {
				url: '/api/noti/countNoneRead',
				method: 'post',
				obj:{},
				req: {
				}
			};
			restAction.actions.ASYNC_COWORK_REST_ACTION({}, param)
				.then(function(res) {
					state.notiCheckTime = time;
					state.notiFirstConnect = false;
					if(res.errorCode == null) {
						if(res.result.count > 0){
							context.commit("setNoneNotiReadYn", true);
						}else{
							context.commit("setNoneNotiReadYn", false);
						}
					}
			})
			.catch(function(err) {
				console.log(err);
			});
		}
	},
	
	setNoneCallReadYn(context, payload){ 
		let time= new Date();
		let connectTime = state.callCheckTime.getTime();
		let currentTime = time.getTime();
		let timeGap = parseInt((currentTime - connectTime)/ (1000*60)); 

		if((timeGap >= 1 || state.callFirstConnect)){
			const param = {
				url: '/api/noti/call/countNoneRead',
				method: 'post',
				obj:{},
				req: {
				}
			};
			restAction.actions.ASYNC_COWORK_REST_ACTION({}, param)
				.then(function(res) {
					state.callCheckTime = time;
					state.callFirstConnect = false;
					if(res.errorCode == null) {
						if( res.result.count > 0){
							context.commit("setNoneCallReadYn", true);
						}else{
							context.commit("setNoneCallReadYn", false);
						}
					}
			})
			.catch(function(err) {
				console.log(err);
			});
		}
	},

	setNotiBoardBlockId(context, payload){
		context.commit("setNotiBoardBlockId", payload);
	},

	setNotiBoardCommentId(context, payload){
		context.commit("setNotiBoardCommentId", payload);
	},

	setShowNotiListPopup(context, payload){
		context.commit("setShowNotiListPopup", payload);
	},

	setShowCallListPopup(context, payload){
		context.commit("setShowCallListPopup", payload);
	},
	
	setEventBackYn(context, payload){
		context.commit("setEventBackYn", payload);
	},
};
const getters = {  
};
  
export default { state, actions, mutations, getters, namespaced: true };
  


// WEBPACK FOOTER //
// ./src/js/store/module/noti/noti.js